import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="input-text-trimmer"
export default class extends Controller<HTMLInputElement> {
  removeSpaces() {
    this.element.value = this.element.value.trim();
  }
}
